module.exports = __webpack_public_path__ + "img/logout_dark.cb4482d4.svg";